import { BusinessPartnerContext, PaymentTaskPhase, PurchaseOrderContractTaskPhase } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 0950. 支払タスクフェーズ一覧
 * [GET] /payment_task_phases
 */
const paymentTaskPhases = (): Promise<PaymentTaskPhase[]> => {
  return axios.get(`/api/payment_task_phases`);
};

export const usePaymentTaskPhases = () => {
  return useQuery({
    queryKey: ['payment_task_phases'],
    queryFn: () => paymentTaskPhases(),
  });
};
